import Constants from 'customs/config/Constants';

import { EventSourcePolyfill } from 'event-source-polyfill';

const eventSource = (url, props) => {
    const auth_token = props.auth.auth_token ? props.auth.auth_token : '';
    return new EventSourcePolyfill(Constants.API_URL + url, {headers: {'Authorization' : 'Bearer ' + auth_token}});
}

export default eventSource;